 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		98: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"components-card-card","3":"ibdPage","5":"components-product_post-product_post~layouts~post-content-sidebar","6":"header~layouts~post-content-body","7":"giftguide","8":"legacyIbdPage","10":"ad-AdContainer","11":"components-analytics-analytics","12":"container","13":"fc_executive_board","14":"Mcp2018Page","15":"aboutUsWpPage","16":"author","17":"category_page","18":"companyIndexSectionPage","19":"companyPage","20":"components-StickyBar-StickyBar","21":"components-all_feed-all_feed","22":"components-editor_highlights-editor_highlights","23":"components-feature_feed-feature_feed","24":"components-feature_term-feature_term","25":"components-finite_scroll","26":"components-franchise_showcase-franchise_showcase","27":"components-megatron-megatron","28":"components-more-stories-component-more-stories-component","29":"components-not_found_component-not_found_component","30":"components-post-content-insert","31":"components-slug-slug","32":"components-video_module-video_module","33":"customCollectionPage","34":"giftpage","35":"legacyMcpPage","36":"loginPage","37":"logoutPage","38":"magazineTagPage","39":"magazine_page","40":"mcp2019Page","41":"myAccountPage","42":"news_page","43":"newsletters_page_marketo","44":"notFoundPage","45":"offerPage","46":"package_article_list_entry","47":"packages-nav-package_sticky_nav","48":"personPage","49":"playlistIndexPage","50":"playlistPage","51":"podcastPage","52":"productIndex","53":"productPage","54":"registerPage","55":"resetPasswordPage","56":"sitemapIndex","57":"sitemapPost","58":"subscribePage","59":"tagPage","60":"videoIndex","61":"videoPage","62":"views-containers-layouts-blank_layout-blank_layout","63":"views-containers-layouts-web_layout-web_layout","93":"MarketoNewsletterForm","94":"MicCarousel","95":"MicIcon","96":"MicMobileIconCarousel","97":"Success-SubmissionSuccess","99":"applications-most-innovative-companies","100":"brands_that_matter_list_page","101":"brands_that_matter_page","102":"components-BackgroundHighlight-BackgroundHighlight","103":"components-MultiTabList-MultiTabList","104":"components-QuickCarousel-QuickCarousel","105":"components-config-config","106":"components-dianomi-dianomi_script","107":"components-fc_link-fc_link","108":"components-footer-footer","109":"components-franchise_accordion_section-franchise_accordion_section","110":"components-franchise_intro-franchise_intro","111":"components-ibd_category-ibd_category","112":"components-image-image","113":"components-magazine_archive-magazine_archive","114":"components-masthead-masthead","115":"components-mcp_section-mcp_section","116":"components-mic_mobile_menu-mic_mobile_menu","117":"components-newsletters-recaptcha","118":"components-person_company_component-person_company_component","119":"components-piano-pianoBottomBanner","120":"components-podcast_tile-podcast_tile","121":"components-podcast_tile-podcast_tile_featured","122":"components-product_post-product_post","123":"components-ranked","124":"components-recirc-recirc","125":"components-related_posts-related_posts","126":"components-related_slider-related_slider","127":"components-sectors_list-sectors_list","128":"components-social-social","129":"components-top_50-top_50","130":"components-top_50_shuffle-top_50_shuffle","131":"components-video_megatron-video_megatron","132":"components-video_module-utils-video_module_ads","133":"containers-pages-list_landers-bwi-2020","134":"containers-pages-list_landers-ibd-2020","135":"containers-pages-list_landers-mic-2021","136":"content-innovation_festival_banner","137":"fc-components-main-components","138":"fc-components-main-components-StickyBar-StickyBar","139":"fc-components-main-containers","140":"fc-components-main-containers-FranchisePageLayout-FranchisePageLayout","141":"fc-components-main-containers-IbdLayout-IbdLayout","142":"fc-components-main-containers-WciLayout-WciLayout","143":"franchises-BtmApplyPage","144":"franchises-BwiApplyPage","145":"franchises-IbdApplyPage","146":"franchises-MicApplyPage","147":"franchises-NbttApplyPage","148":"franchises-WciApplyPage","149":"header","150":"innovation_by_design_future_page","151":"innovation_by_design_page_franchise","152":"layouts","153":"layouts-mcp","154":"post-content-body","155":"post-content-sidebar"}[chunkId]||chunkId) + "." + {"1":"310bb9901c3e0ff2b669","2":"35d8d80f7a11f8590fa9","3":"f0b223fe057f4195d39b","4":"1c57a9f9e86dea55d794","5":"d2dd423f35b87dd35ce6","6":"4aa9154993c2bdbbc8f2","7":"9e9ecbab9a8f990c257d","8":"bb5a63e014b5adf8a0b3","9":"065f32fc181c1881c5e6","10":"785980d2d826362381ab","11":"9f23ef446c761c9d95bf","12":"4aa03a602e1c645bffdd","13":"f1338aed48780c113e1b","14":"10510bec5836d5bb665c","15":"6a5de40585d2f8a78fc5","16":"a0ef9f13b43059e6d62b","17":"d6d43fa5f600105de183","18":"ff982b6b7494af4b6e4b","19":"add936f38d2fd13af589","20":"971715cdea434d3455f1","21":"269e42b131f43b6c3b54","22":"57d5f94aaa69ba838f03","23":"7ac5cfcd90aa09732f9f","24":"50159cd6241c998c0728","25":"b62469ddba516e6f039e","26":"c3310092e2953c55bc0b","27":"b57697feb6751b8d71da","28":"2e9f2fada6d9eebff376","29":"0a7d844b95a87394cf5c","30":"4328bcdf9697e9a2bdc3","31":"0e5c84a905be15eddf88","32":"e864a5a7ae6634050dbf","33":"b18b65db521ec9043514","34":"ae23329a021f5876c7eb","35":"aa522199512805c1826e","36":"571fa7a6de249084f017","37":"ed4125365b48d957553e","38":"0ec4ecd158f081afd4d7","39":"d43d76b4d6280c4a1d3b","40":"a9492316c4ff48a5d3f3","41":"69d070600fa248fc8cca","42":"e0ca975f65da03fb0ec9","43":"135bb3cee1a12ca5251c","44":"3b3ae6c95908d7d3790a","45":"26a60757d53b0f250c89","46":"d01734f209e0fdd671e6","47":"29da1aabf3c8e10f2175","48":"ba2ce4c325599cf4bfa0","49":"c2a1c147b39ef45c2f85","50":"38aeac6a3638bf93c4ac","51":"20f1db2d9f4e21b29e91","52":"01e8f085f8a60d275d83","53":"7169ad2fef6ef0da44b0","54":"7a3dc5227272670e0ca8","55":"49ab8e02942d1e81ca74","56":"96712e83d058484bafe7","57":"455c2b68ee2d639bd42a","58":"6026073c43f640ba6313","59":"8b549faf255f56d80c5e","60":"e4cb87b3cbc7876e808e","61":"34c5c60f32697b194188","62":"8a93178b2e0e2dde6472","63":"b179e26181b274aadac6","64":"f30974dcf7132bf56999","65":"a0c9817e45b048af8e3a","66":"789b1a5ee1c2b67765e1","67":"697ad7e1366bd988a89d","68":"7c49f24cfab511c8797e","69":"9e13ddddd850338ae531","70":"6bc7e56aa50040336931","71":"fbb4fe1e2e164f3a65b7","72":"c37835e6f5a8aa23355f","73":"4a468ec8bb86d47a4230","74":"7893c46e1c860c9dfbcf","75":"07d9f92bcc020cb02f74","76":"980f9e733805064f1e70","77":"f87c62cc22a230b54195","78":"67b3fa00f25151a0e3a0","79":"8a2f042c6a8a241acd31","80":"ad6db0034c6c61cf3f0b","81":"3a3fa16849319061af7f","82":"89b5ce5a7c61570682fa","83":"0c29f1878aa10bfa8f6e","84":"ebd9d726fb03379baebc","85":"fc00f58d277cb610e8bf","86":"c99a7fd3259cbe1ac917","87":"d29d77c7d8de9fc3d142","88":"efd6df00041964239d93","89":"1f3ef6d988dd08f51cec","90":"290bdb4ef83210a24316","91":"1970ac34063d4c2c9be4","92":"968aaabff00ccab1132d","93":"490aae92b3456ed0dbd2","94":"c2cf9f0839f6ffa0008d","95":"b67d2c4d4738852f0dc7","96":"359c7e2db006c2501ed1","97":"fa58620f39ca9840d345","99":"bcfbdbb8a9522b35169c","100":"9b0b51943c7ef60ad178","101":"aa4feb18344e7af58f0d","102":"c9249b3c3253bb676c9a","103":"c80db6c4efbce9adff51","104":"9ffa18d6f21a5ca6e213","105":"1c34b6eb1dd01f1db2e1","106":"7b5e27688d4719dc34f4","107":"4c4e9ee23a7960485420","108":"0c3b2f98c35150fa8921","109":"6f8e4317c7d57508d3ca","110":"480c9b228145ffc8b118","111":"2180365555332a1ebec5","112":"c0e9e95ce6d1dcbe9031","113":"57fe6a252f0223c3ff9a","114":"055ba6d5ea2983a3d48f","115":"e4cf260a40aca34f887a","116":"dfbae669813ab9e30bfb","117":"157c78448f6b0c1bea20","118":"4734b3d6670484bd3ed0","119":"112acea14252bd2233d7","120":"4407f0e86aa69f7f1676","121":"9c5076a95a5347729ce7","122":"7da6d4ae58c117a4ab6b","123":"406267e7cd0db50f3882","124":"ada927d37c9f9dd764d6","125":"b3add6a0fb10174bb5c9","126":"63b15f7be1894d174f8f","127":"d34099a693093abd82d3","128":"e76466e1214688720156","129":"04d32cc5dacbb7f9fa92","130":"859daf0364aa1ecaec53","131":"bd29c60a0a17c9d9c0c7","132":"cf63b3f8c6769fe6c43d","133":"bc202b76747871e59f26","134":"c9bdbbff320aff7322ef","135":"72f597dc45343350b15a","136":"25b0b8ee4581b50f6089","137":"f8245f4ee4e9a55fb828","138":"9fc4ef4d96a123186427","139":"e4fa4589692deab301cf","140":"181d38bc0b1befdada6b","141":"7379b38e1b2425f79bd9","142":"2800f31bc101c7087568","143":"23a39301d5301340d273","144":"d6da5f49e87f51942b8d","145":"70bb14ee4661fb6d93b4","146":"8b9da684904bdd832d6b","147":"e7eca6ec9ed0b2a18dd5","148":"33a8214f0a31573ec65f","149":"ba3885e93a1ee56dffdb","150":"d4a237898818d24b9631","151":"82fdb54de9460424c81d","152":"d4d26459c16ab36b2c01","153":"8810458fc9bccd4019e6","154":"67be1772d2c7ef7d7000","155":"25b02196b2e46058bcf4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.fastcompany.com/_/fc/bundle/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([786,0]);
 	// run deferred modules when ready
 	return checkDeferredModules();
